import { render, staticRenderFns } from "./CartPositionItem.vue?vue&type=template&id=8b39382c&scoped=true"
import script from "./CartPositionItem.vue?vue&type=script&lang=ts"
export * from "./CartPositionItem.vue?vue&type=script&lang=ts"
import style0 from "./CartPositionItem.vue?vue&type=style&index=0&id=8b39382c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b39382c",
  null
  
)

export default component.exports